import { render, staticRenderFns } from "./GetGasModal.vue?vue&type=template&id=66db4c7d"
import script from "./GetGasModal.vue?vue&type=script&lang=ts"
export * from "./GetGasModal.vue?vue&type=script&lang=ts"
import style0 from "./GetGasModal.vue?vue&type=style&index=0&id=66db4c7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports